import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { NewPrimaryAdminSelect } from 'adminDashboard/common'
import { Formik } from 'formik'

import { CompanyAdmin, removeAdmin } from 'core'

import { Alert, Button, Icon, Modal, Notification, Row } from 'common/components'
import { useCommandRequestV2 } from 'common/hooks'

import './styles.less'

interface Props {
  visible: boolean
  userToRemove: CompanyAdmin | null
  onAddAdmin?: () => void
  onCancel: () => void
}

const LastPrimaryAdminModal = ({ visible, userToRemove, onCancel, onAddAdmin }: Props) => {
  const { t: translate } = useTranslation()
  const [employeesAreLoading, setEmployeesAreLoading] = useState(false)

  const { sendCommand: removeAdminCommand, isLoading: removeAdminIsLoading } = useCommandRequestV2(removeAdmin)

  const handleRemoveAdmin = async (assignAdminToId: string) => {
    const deleteResponse = await removeAdminCommand({ id: userToRemove.id, assignAdminToId })
    if (!deleteResponse.hasErrors) {
      onAddAdmin && onAddAdmin()
      Notification.open({
        message: translate('admin-dashboard.company-settings.company-admins.remove-admin-success-message'),
        type: 'success',
      })
    }
  }

  const handleSubmit = async ({ assignAdminToId }) => {
    await handleRemoveAdmin(assignAdminToId)
    onCancel()
  }

  return (
    visible && (
      <Modal className="new-primary-admin__modal" visible={visible} onCancel={onCancel} okText="Confirm" footer={null}>
        <Row className="px-16">
          <Alert
            showIcon
            alignItems="top"
            icon={<Icon fontAwesome type="fa fa-question-circle" className="mr-16 mt-12 fa-lg" />}
            type="warning"
            banner={true}
            style={{ backgroundColor: 'inherit' }}
            message={
              <p className="semi-bold">
                You are about to remove your Plan Admin, who is required to be listed on all plan documents. Please
                select a user to transfer the Plan Admin role to.
              </p>
            }
          />

          <Formik initialValues={{ assignAdminToId: '' }} onSubmit={handleSubmit}>
            {({ handleSubmit }) => (
              <form className="new-primary-admin__form px-16 w-100" onSubmit={handleSubmit}>
                <NewPrimaryAdminSelect
                  excludeCompanyUserId={userToRemove.id || null}
                  onLoading={setEmployeesAreLoading}
                />
                <Button
                  className="new-primary-admin__submit-button"
                  htmlType="submit"
                  type="primary"
                  disabled={employeesAreLoading || removeAdminIsLoading}
                  loading={removeAdminIsLoading}
                >
                  Confirm
                </Button>
              </form>
            )}
          </Formik>
        </Row>
      </Modal>
    )
  )
}

export default LastPrimaryAdminModal
